<template>
	<div class="generic-tool-result-surface-root">
		<div v-if="resultRendererComponent" class="generic-tool-result-surface-root__content">
			<div
				v-if="title || resultPrintRendererComponent"
				class="qw-row align-items-center mb-4">
				<h1 v-if="title" class="mb-0">{{ title }}</h1>
				<div class="layout-spacer"/>
				<qw-button
					v-if="resultPrintRendererComponent"
					class="hide-on-print"
					@click="onPrintResultClicked">
					<i class="fontello icon-print"></i> Print response
				</qw-button>
			</div>

			<component
				:is="resultRendererComponent"
				v-model:tool-result="localToolResult"
				:tool-instance="toolInstance"
				:engine-api="engineApi"
				:render-context="renderContext"
				@change="$emit('change')"
				@print-client-copy="onPrintClientCopyClicked"
				@create-revision="$emit('create-revision', $event)"
			/>
		</div>
	</div>
</template>

<script>
import ViewModeComponent from "@/core/components/ViewModeComponent.vue";

export default {
	name: "GenericToolResultSurface",
	extends: ViewModeComponent,

	props: {
		title: String,
		toolType: String,
		toolInstance: Object,
		toolResult: Object,
		resultRendererComponent: [Object, Function],
		resultPrintRendererComponent: [Object, Function],
		engineApi: Object,
		renderContext: Object,
		longitudinalView: Object,
		comparisonView: Object,
		longitudinalRendererId: String,
		longitudinalRounds: Array,
	},

	emits: ["update:toolResult", "change", "create-revision"],

	computed: {
		localToolResult: {
			get() {
				return this.toolResult
			},
			set(value) {
				this.$emit("update:toolResult", value)
			},
		},
	},

	methods: {
		onPrintResultClicked() {
			this.openPrint("PrintGenericTool", {
				mode: "result",
				toolType: this.toolType,
				toolInstance: this.toolInstance,
				toolResult: this.toolResult,
				priorResults: this.renderContext?.priorResults || [],
					participationReview: this.renderContext?.participationReview || null,
				longitudinalView: this.longitudinalView || null,
				comparisonView: this.comparisonView || null,
				longitudinalRendererId: this.longitudinalRendererId || "",
				longitudinalRounds: this.longitudinalRounds || [],
			})
		},
		onPrintClientCopyClicked() {
			this.openPrint("PrintGenericTool", {
				mode: "result",
				clientCopy: true,
				toolType: this.toolType,
				toolInstance: this.toolInstance,
				toolResult: this.toolResult,
			})
		},
	},
}
</script>
